import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataLayout: sessionStorage.getItem("dataLayout") || "default",
  dataWidth: sessionStorage.getItem("dataWidth") || "fluid",
  dataCard: sessionStorage.getItem("dataCard") || "bordered",
  dataSidebar: sessionStorage.getItem("dataSidebar") || "light",
  dataSidebarAll: sessionStorage.getItem("dataSidebarAll") || "",
  dataTopbarAll: sessionStorage.getItem("dataTopbarAll") || "",
  dataTopBarColorAll: sessionStorage.getItem("dataTopBarColorAll") || "",
  dataColorAll: sessionStorage.getItem("dataColorAll") || "",
  dataTheme: sessionStorage.getItem("dataTheme") || "light",
  dataTopBar: sessionStorage.getItem("dataTopBar") || "white",
  dataTopBarColor: sessionStorage.getItem("dataTopBarolor") || "white",
  dataSidebarBg: sessionStorage.getItem("dataSidebarBg") || "",
  dataTopbarBg: sessionStorage.getItem("dataTopbarBg") || "",
  dataColor: sessionStorage.getItem("dataColor") || "primary",
  dataLoader: sessionStorage.getItem("dataLoader") || "enable",
  isRtl: sessionStorage.getItem("rtl") || false,
  headerCollapse: false,
};

const themeSettingSlice = createSlice({
  name: "themeSetting",
  initialState,
  reducers: {
    setHeaderCollapse: (state, { payload }) => {
      state.headerCollapse = payload;
    },
    setDataLayout: (state, action) => {
      state.dataLayout = action.payload;
      sessionStorage.setItem("dataLayout", action.payload);
      document.documentElement.setAttribute("data-layout", action.payload);
    },
    setDataWidth: (state, action) => {
      state.dataWidth = action.payload;
      sessionStorage.setItem("dataWidth", action.payload);
      document.documentElement.setAttribute("data-width", action.payload);
    },
    setDataCard: (state, action) => {
      state.dataCard = action.payload;
      sessionStorage.setItem("dataCard", action.payload);
      document.documentElement.setAttribute("data-card", action.payload);
    },
    setDataSidebar: (state, action) => {
      state.dataSidebar = action.payload;
      sessionStorage.setItem("dataSidebar", action.payload);
      document.documentElement.setAttribute("data-sidebar", action.payload);
    },
    setDataSidebarAll: (state, action) => {
      state.dataSidebarAll = action.payload;
      sessionStorage.setItem("dataSidebarAll", action.payload);
    },
    setDataColorAll: (state, action) => {
      state.dataColorAll = action.payload;
      sessionStorage.setItem("dataColorAll", action.payload);
    },
    setDataTopBarColorAll: (state, action) => {
      state.dataTopBarColorAll = action.payload;
      sessionStorage.setItem("dataTopBarColorAll", action.payload);
    },
    setDataTopbarAll: (state, action) => {
      state.dataTopbarAll = action.payload;
      sessionStorage.setItem("dataTopbarAll", action.payload);
    },
    setDataTheme: (state, action) => {
      document.documentElement.setAttribute("data-theme", action.payload);
      state.dataTheme = action.payload;
      sessionStorage.setItem("dataTheme", action.payload);
    },
    setTopBarColor: (state, action) => {
      state.dataTopBar = action.payload;
      sessionStorage.setItem("dataTopBar", action.payload);
      document.documentElement.setAttribute("data-topbar", action.payload);
    },
    setTopBarColor2: (state, action) => {
      state.dataTopBarColor = action.payload;
      sessionStorage.setItem("dataTopBarColor", action.payload);
      document.documentElement.setAttribute("data-topbarcolor", action.payload);
    },

    setDataSidebarBg: (state, action) => {
      state.dataSidebarBg = action.payload;
      sessionStorage.setItem("dataSidebarBg", action.payload);
      document.body.setAttribute("data-sidebarbg", action.payload);
    },
    setDataTopbarBg: (state, action) => {
      state.dataTopbarBg = action.payload;
      sessionStorage.setItem("dataTopbarBg", action.payload);
      document.body.setAttribute("data-topbarbg", action.payload);
    },
    setDataColor: (state, action) => {
      state.dataColor = action.payload;
      sessionStorage.setItem("dataColor", action.payload);
      document.documentElement.setAttribute("data-color", action.payload);
    },
    setLoader: (state, action) => {
      state.dataLoader = action.payload;
      sessionStorage.setItem("dataLoader", action.payload);
      document.documentElement.setAttribute("data-loader", action.payload);
    },
    setRtl: (state, action) => {
      state.isRtl = action.payload;
      sessionStorage.setItem("rtl", action.payload);
      document.body.setAttribute("class", action.payload);
    },
    resetAllMode: (state: any) => {
      state.dataLayout = "default";
      state.dataWidth = "fluid";
      state.dataCard = "bordered";
      state.dataSidebar = "light";
      state.dataTheme = "light";
      state.dataTopBar = "white";
      state.dataTopBarColor = "white";
      state.dataSidebarBg = "";
      state.dataTopbarBg = "";
      state.dataColor = "primary";
      state.dataLoader = "enable";
      state.isRtl=""
      sessionStorage.setItem("dataLayout", "default");
      sessionStorage.setItem("dataWidth", "fluid");
      sessionStorage.setItem("dataCard", "bordered");
      sessionStorage.setItem("dataSidebar", "light");
      sessionStorage.setItem("dataTheme", "light");
      sessionStorage.setItem("dataTopBar", "white");
      sessionStorage.setItem("dataTopBarColor", "white");
      sessionStorage.setItem("dataSidebarBg", "");
      sessionStorage.setItem("dataTopbarBg", "");
      sessionStorage.setItem("dataColor", "primary");
      sessionStorage.setItem("dataLoader", "enable");
      sessionStorage.setItem("rtl", "");
    },
  },
});

export const {
  setDataLayout,
  setDataWidth,
  setDataCard,
  resetAllMode,
  setTopBarColor,
  setDataTheme,
  setDataSidebar,
  setDataSidebarAll,
  setDataColorAll,
  setDataTopBarColorAll,
  setDataTopbarAll,
  setDataSidebarBg,
  setDataTopbarBg,
  setHeaderCollapse,
  setDataColor,
  setLoader,
  setTopBarColor2,
  setRtl,
} = themeSettingSlice.actions;

export default themeSettingSlice.reducer;
